import gql from 'graphql-tag'

// Refused once any market of the wave has left draft. It also syncs the wave's
// exclusion groups, and if that sync fails the selection stays saved and the
// call fails: calling again with the same selection only syncs.
export const SET_WAVE_EXCLUSIONS_V2 = gql`
  mutation setWaveExclusionsV2($input: SetWaveExclusionsV2Input!) {
    setWaveExclusionsV2(input: $input) {
      waveId
      excludedWaveIds
    }
  }
`
